import { render, staticRenderFns } from "./ElaboratedItemList.vue?vue&type=template&id=da065924"
import script from "./ElaboratedItemList.vue?vue&type=script&lang=js"
export * from "./ElaboratedItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports